import client from "api/client";


const _client = client.route("/profile");

const profile = {
	get: (id) => _client.get(`/${id}`),
	ensure: (payload) => _client.post("", payload),
	reload: (payload) => _client.post("/reload", payload)
};

export default profile;